<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[960px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">
              {{ checkEdit ? "แก้ไขศูนย์พักพิง" : "สร้างศูนย์พักพิง" }}
            </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="flex flex-col gap-[16px] p-[20px] overflow-auto">
            <div
              class="max-h-[536px] flex justify-center items-start gap-[30px] overflow-auto flex-wrap md:flex-nowrap"
            >
              <!-- upload image -->
              <UploadImage v-model:image="form.image" imageDefault="shelter" />
              <!-- upload image -->
              <div class="w-full flex flex-col gap-[16px]">
                <div
                  class="flex items-start gap-[16px] flex-wrap sm:flex-nowrap"
                >
                  <SelectBoxComponent
                    :selectContainerClass="'w-full sm:max-w-[250px]'"
                    :inputId="'shelter_type'"
                    :searchable="true"
                    :allowEmpty="true"
                    :keyValue="'id'"
                    :keyName="'name'"
                    :options="AllShelterType"
                    :value="form.shelter_type"
                    :label="'ประเภทศูนย์พักพิง'"
                    :placeholder="'ประเภทศูนย์พักพิง'"
                    @update:modelValue="
                      (res) => {
                        form.shelter_type = res;
                      }
                    "
                  />
                  <div class="w-full flex flex-col gap-[8px]">
                    <AutoCompleteInput
                      id="name"
                      label="ชื่อศูนย์พักพิง"
                      placeholder="ชื่อศูนย์พักพิง"
                      v-model="form.name"
                      :fetcher="fetchShelterName"
                      :itemText="
                        (it) => (typeof it === 'string' ? it : it?.name ?? '')
                      "
                      :itemValue="
                        (it) => (typeof it === 'string' ? it : it?.name ?? '')
                      "
                      notFoundText="ไม่พบข้อมูล"
                      @select="onPickShelterName"
                    />
                    <div v-if="errors.name" class="textError">
                      {{ errors.name }}
                    </div>
                  </div>
                </div>
                <Input
                  label="เบอร์โทรศูนย์"
                  placeholder="เบอร์โทรศูนย์"
                  v-model="form.phone"
                  :warningMessage="errors.phone"
                  @input="form.phone = $validateInputPhoneNum(form.phone)"
                />
                <!-- datePicker -->
                <DatePicker2
                  label="ก่อตั้งเมื่อ"
                  :modelValue="form.created_date"
                  :warningMessage="errors.created_date"
                  @update:modelValue="(date) => selectCreateDate(date)"
                />
                <!-- datePicker -->
                <div
                  class="w-full grid grid-cols-1 sm:grid-cols-3 items-start gap-[8px]"
                >
                  <div class="label sm:col-span-3">ตำแหน่งศูนย์พักพิง</div>
                  <div
                    class="sm:col-span-3 w-full grid grid-cols-1 sm:grid-cols-3 items-start gap-[14px]"
                  >
                    <SelectBoxComponent
                      :inputId="'provinceSelector'"
                      :searchable="true"
                      :allowEmpty="true"
                      :keyValue="'provinceCode'"
                      :keyName="'provinceNameTh'"
                      :value="form.province_code"
                      :placeholder="'เลือกจังหวัด'"
                      :warningMessage="errors.province_code"
                      :disabled="true"
                      @update:modelValue="
                        (res) => {
                          form.province_code = res;
                          form.district_code = '';
                          form.subdistrict_code = '';
                          form.postal_code = '';
                          form.geography_id = '';
                        }
                      "
                    />
                    <SelectBoxComponent
                      :inputId="'districtSelector'"
                      :searchable="true"
                      :allowEmpty="true"
                      :keyValue="'districtCode'"
                      :keyName="'districtNameTh'"
                      :value="form.district_code"
                      :provinceCode="form.province_code"
                      :placeholder="'เลือก เขต/อำเภอ'"
                      :warningMessage="errors.district_code"
                      @update:modelValue="
                        (res) => {
                          form.district_code = res;
                          form.subdistrict_code = '';
                          form.postal_code = '';
                          form.geography_id = '';
                        }
                      "
                    />
                    <SelectBoxComponent
                      :searchable="true"
                      :allowEmpty="true"
                      :inputId="'subDistrictSelector'"
                      :keyValue="'subdistrictCode'"
                      :keyName="'subdistrictNameTh'"
                      :value="form.subdistrict_code"
                      :districtCode="form.district_code"
                      :placeholder="'เลือก แขวง/ตำบล'"
                      :warningMessage="errors.subdistrict_code"
                      :allData="true"
                      @update:modelValue="
                        (res) => {
                          if (res && res.subdistrictCode) {
                            form.subdistrict_code = res.subdistrictCode;
                            form.postal_code = res.postalCode;
                            form.geography_id = res.id;
                          }
                        }
                      "
                    />
                  </div>
                </div>
                <div
                  class="w-full grid grid-cols-1 sm:grid-cols-3 items-start gap-[14px]"
                >
                  <Input
                    placeholder="รหัสไปรษณีย์"
                    v-model="form.postal_code"
                    :warningMessage="errors.postal_code"
                    :disabled="true"
                  />
                  <div class="sm:col-span-2">
                    <AutoCompleteInput
                      id="address"
                      placeholder="บ้านเลขที่, หมู่ที่, ซอย, และข้อมูลอื่นๆ"
                      v-model="form.address"
                      :fetcher="fetchAddress"
                      :itemText="
                        (it) => (typeof it === 'string' ? it : it?.name ?? '')
                      "
                      :itemValue="
                        (it) => (typeof it === 'string' ? it : it?.name ?? '')
                      "
                      notFoundText="ไม่พบข้อมูล"
                      @select="onPickAddress"
                    />
                  </div>
                </div>

                <Input
                  label="จำนวนคนที่รับได้"
                  placeholder="ระบุตัวเลข"
                  :inputType="'number'"
                  :inputClass="'no-spinner'"
                  v-model="form.max_capacity"
                  :warningMessage="errors.max_capacity"
                />
                <div class="flex flex-col gap-[8px]">
                  <div class="PC_Body2-SB text-[#1F1D1F]">สถานะ</div>
                  <Switch
                    :active="form.status"
                    @toggleSlider="updateShelterStatus"
                  />
                </div>
                <div class="flex flex-col items-start gap-[20px]">
                  <div class="PC_Body2-SB">
                    สาธารณูปโภคประจำศูนย์ (ไม่บังคับ)
                  </div>
                  <div
                    v-if="errors.utilities"
                    :class="['textError', { 'mt-[8px]': errors.utilities }]"
                  >
                    {{ errors.utilities }}
                  </div>
                  <div
                    v-for="(util, index) in AllUtilityMap"
                    :key="index"
                    class="w-full sm:w-fit flex flex-col items-start gap-[16px]"
                  >
                    <div class="flex items-center gap-[10px]">
                      <div class="h-[21px] w-[4px] bg-[#EECCE7]"></div>
                      <div class="PC_Body2-SB text-[#1F1D1F]">
                        {{ util.name }}
                      </div>
                    </div>
                    <Radio
                      :id="'resources_choice1' + index"
                      v-model="util.is_active"
                      :name="'resources_choice1' + index"
                      :value="1"
                      :label="'ไม่มี'"
                    />
                    <Radio
                      :id="'resources_choice2' + index"
                      v-model="util.is_active"
                      :name="'resources_choice2' + index"
                      :value="2"
                      :label="'มี'"
                    />
                    <Input
                      v-if="util.id == 7"
                      placeholder="ระบุ"
                      :disabled="Number(util.is_active) == 1"
                      v-model="util.description"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end items-center gap-[10px]">
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--onlySave'"
                :disabled="isAllEmpty || id7NeedsDesc"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, nextTick } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useShelterStore } from "@/pinia/shelter";
import { storeToRefs } from "pinia";

const { $validateMsg, $buildFormData, $formatDate3 } = useGlobals();
const shelterStore = useShelterStore();
const { AllUtility, AllShelterType } = storeToRefs(shelterStore);

const input = {
  image: "",
  name: "",
  phone: "",
  shelter_type: "",
  created_date: "",
  geography_id: "",
  province_code: "",
  district_code: "",
  subdistrict_code: "",
  postal_code: "",
  address: "",
  max_capacity: "",
  status: 2,
  utilities: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const AllUtilityMap = ref([]);
const modalIsOpened = ref(false);
// const selectedUtilities = ref([]);
const checkEdit = ref(false);

const emit = defineEmits(["status"]);

const excludedKeys = ["image", "utilities"];

// หา utility id = 7
const util7 = computed(() => AllUtilityMap.value.find((u) => u.id === 7));

// ถ้ากลับไปเลือก "ไม่มี" (is_active == 1) ให้เคลียร์ description
watch(
  () => util7.value && util7.value.is_active,
  (val) => {
    if (!util7.value) return;
    if (Number(val) === 1) util7.value.description = "";
  }
);

// ต้องกรอก description เมื่อเลือก "มี" (is_active == 2)
const id7NeedsDesc = computed(() => {
  if (!util7.value) return false;
  const active = Number(util7.value.is_active);
  const desc = (util7.value.description || "").trim();
  return active === 2 && desc.length === 0;
});

// watch(AllUtility, (newVal) => {
//   AllUtilityMap.value = newVal.map((item) => ({
//     ...item,
//     is_active: 1,
//     description: item.id == 7 ? "" : null,
//   }));
// });

const isAllEmpty = computed(() => {
  return Object.entries(form.value)
    .filter(([key]) => !excludedKeys.includes(key))
    .some(([, value]) => value === "");
});

const syncUtilitiesFromItem = (item) => {
  const utilMap = new Map(
    (item?.utilities || []).map((u) => [Number(u.id), u])
  );

  AllUtilityMap.value = (AllUtility.value || []).map((base) => {
    const hit = utilMap.get(Number(base.id));
    return {
      ...base,
      is_active: hit ? 2 : 1,
      description: base.id === 7 ? hit?.description ?? "" : null,
    };
  });

  form.value.utilities = AllUtilityMap.value
    .filter((u) => u.is_active === 2)
    .map((u) => u.id);
};

const openModal = async (item) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };

  form.value.province_code = await JSON.parse(
    localStorage.getItem("user_province_id")
  );
  checkEdit.value = !!item;
  if (item) {
    form.value = {
      ...form.value,
      image: item.image,
      id: item.id,
      name: item.original_name,
      phone: item.phone,
      created_date: new Date(item.created_date),
      geography_id: item.geography_id,
      province_code: item.province_code,
      district_code: item.district_code,
      subdistrict_code: item.subdistrict_code,
      postal_code: item.postal_code,
      address: item.address,
      max_capacity: item.max_capacity,
      status: item.status,
      shelter_type: item.shelter_type,
      utilities: item.utilities.map((util) => util.id),
    };

    // selectedUtilities.value = item.utilities.map((util) => Number(util.id));
  }
  syncUtilitiesFromItem(item);
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const selectCreateDate = (date) => {
  form.value.created_date = date;
};

const updateShelterStatus = async (item) => {
  form.value.status = item ? 1 : 2;
};

const save = () => {
  if (checkEdit.value) {
    update();
  } else {
    add();
  }
};

const isURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const buildUtilitiesPayload = (list) => {
  return list
    .filter((item) => {
      if (item.is_active !== 2) return false;
      if (item.id === 7) {
        const desc = (item.description ?? "").trim();
        return desc.length > 0;
      }
      return true;
    })
    .map((item) => {
      const payload = {
        id: item.id,
        is_active: 1,
      };
      if (item.id === 7) {
        payload.description = (item.description ?? "").trim();
      }
      return payload;
    });
};

const update = async () => {
  const selectedUtilities = buildUtilitiesPayload(AllUtilityMap.value);

  const body = {
    ...(isURL(form.value.image)
      ? { ...form.value, image: undefined }
      : form.value),
    created_date: $formatDate3(form.value.created_date),
    utilities: selectedUtilities,
  };
  if (body.image === undefined) {
    delete body.image;
  }
  let formData = new FormData();
  const data0 = $buildFormData(formData, body);
  await shelterStore
    .updateShelter(form.value.id, data0)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

const add = async () => {
  const selectedUtilities = buildUtilitiesPayload(AllUtilityMap.value);

  const body = {
    ...form.value,
    created_date: $formatDate3(form.value.created_date),
    utilities: selectedUtilities,
  };
  let formData = new FormData();
  const data0 = $buildFormData(formData, body);
  await shelterStore
    .createShelter(data0)
    .then((response) => {
      if (response.status === 201) {
        emit("status", response.data.message, "success");
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      } else {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

// const toggleUtility = async (checked, id) => {
//   if (checked) {
//     if (!selectedUtilities.value.includes(id)) {
//       selectedUtilities.value.push(id);
//     }
//   } else {
//     selectedUtilities.value = selectedUtilities.value.filter(
//       (item) => item !== id
//     );
//   }
// };

// ---------------autoComplete---------------
function normalizeAutoComplete(res) {
  if (Array.isArray(res)) return res;
  const arr = res?.data?.data?.data ?? res?.data?.data ?? [];
  return Array.isArray(arr) ? arr : [];
}

const fetchShelterName = async ({ query, offset }) => {
  await nextTick();
  const q = typeof query === "string" ? query : "";
  const res = await shelterStore.getShelterPoint({
    search: q,
    offset: offset ?? 0,
  });
  return normalizeAutoComplete(res);
};

// const fetchShelterType = async ({ query, offset }) => {
//   await nextTick();
//   const q = typeof query === "string" ? query : "";
//   const res = await shelterStore.getShelterType({
//     search: q,
//     offset: offset ?? 0,
//   });
//   return normalizeAutoComplete(res);
// };

const fetchAddress = async ({ query, offset }) => {
  await nextTick();
  const q = typeof query === "string" ? query : "";
  const res = await shelterStore.autoCompleteAddress({
    search: q,
    offset: offset ?? 0,
  });
  return normalizeAutoComplete(res);
};

function onPickShelterName(_item) {
  /* ถ้าต้องทำอย่างอื่นเพิ่ม ใส่ตรงนี้ */
}
// function onPickShelterType(_item) {
//   /* ถ้าต้องทำอย่างอื่นเพิ่ม ใส่ตรงนี้ */
// }
function onPickAddress(_item) {
  /* ถ้าต้องทำอย่างอื่นเพิ่ม ใส่ตรงนี้ */
}
defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.label {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
</style>
